import { PartialTranslation } from '../translations';

export const hy: PartialTranslation = {
  newChat: 'Նոր զրույց',
  search: 'Փնտրել',
  user: 'Օգտատեր',
  settings: 'Կարգավորումներ',
  language: 'Լեզու',
  getHelp: 'Ստանալ օգնություն',
  viewAllPlans: 'Տեսնել բոլոր ծրագրերը',
  learnMore: 'Իմանալ ավելին',
  logOut: 'Դուրս գալ',
  chooseLanguage: 'Выберите язык',
  chooseYourPreferredLanguage: 'Выберите предпочитаемый язык',
  searchLanguages: 'Поиск языков...',
  autoDetect: 'Ավտոմատ հայտնաբերում',
  noLanguagesFound: 'Языки не найдены',
  askAnything: 'Հարցրեք ամեն ինչ',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Անձնական',
  freePlan: 'Անվճար ծրագիր',
  current: 'Текущий',
  close: 'Закрыть',
  archive: 'Архивировать',
  delete: 'Удалить',
  confirmDelete: 'Вы уверены, что хотите удалить этот чат?',
  confirmArchive: 'Вы уверены, что хотите архивировать этот чат?',
  deleteCannotUndo: 'Это действие нельзя отменить.',
  archiveCanFind: 'Вы сможете найти его в списке архива после архивирования.',
  
  // 资源面板
  resources: 'Ռեսուրսներ',
  addResource: 'Ավելացնել ռեսուրս',
  deleteResource: 'Удалить ресурс',
  noMatchingResourcesFound: 'Подходящие ресурсы не найдены',
  noResourcesAvailable: 'Ресурсы недоступны',
  hideResources: 'Скрыть ресурсы',
  showResources: 'Показать ресурсы',
  
  // 聊天输入框
  typeMessage: 'Գրեք հաղորդագրություն...',
  thinkingOptions: 'Варианты размышления',
  deleteFile: 'Удалить файл',
  clearSelection: 'Очистить выбор',
  addAttachment: 'Ավելացնել կցորդ',
  sendMessage: 'Ուղարկել հաղորդագրություն',
  
  // 思考模式选项
  deepInsight: 'Глубокое понимание · Поверхностный анализ',
  deepInsightDesc: 'Быстрое понимание ключевых моментов',
  deepExploration: 'Глубокое исследование · Комплексный анализ',
  deepExplorationDesc: 'Многомерное углубленное исследование',
  deepDeconstruction: 'Глубокая деконструкция · Систематический аргумент',
  deepDeconstructionDesc: 'Послойный прогрессивный анализ',
  
  // 写作模式选项
  contractReview: 'Обзор контракта · Выявление рисков',
  contractReviewDesc: 'Анализ пунктов и проверка соответствия',
  textPolish: 'Полировка текста · Профессиональное выражение',
  textPolishDesc: 'Языковая оптимизация и структурная настройка',
  legalDocuments: 'Правовые документы · Стандартный проект',
  legalDocumentsDesc: 'Профессиональное написание правовых документов',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Մուտdelays',
  register: 'Գdelays',
  welcomeBack: 'Բdelays delays LawHelper',
  loginSubtitle: ' Delays AI delaysdelays delaysdelays',
  continueWithGoogle: 'Delays Google-delays',
  continueWithMicrosoft: 'Delays Microsoft-delays',
  continueWithWeChat: 'Delays WeChat-delays',
  orContinueWith: 'delaysdelays',
  emailTab: 'Էdelays',
  phoneTab: 'Հdelays',
  emailPlaceholder: 'Delaysdelays էdelays',
  phonePlaceholder: 'Delaysdelays delays',
  codePlaceholder: 'Delays 6-delays delays',
  sending: 'Delays...',
  verifying: 'Delays...',
  verify: 'delays',
  sendMagicLink: 'Delays delays delay',
  getVerificationCode: 'Delays delay',
  resendCode: 'Delays delay',
  resendIn: 'Delays',
  magicLinkSent: 'Delay delay delay delay delay',
  magicLinkHint: 'Delay delay delay delay delay',
  otpSent: 'Delay delay delay',
  agreeToTerms: 'Delay delay delay delay',
  privacyPolicy: 'Delay Delay',
  termsOfService: 'Delay Delay',
  and: 'delay',
  privacyTitle: 'Delay Delay Delay',
  privacyIntro: 'Delay delay delay delay delay delay.',
  essentialCookies: 'Delay delay',
  essentialDesc: 'Delay delay delay',
  analyticsCookies: 'Delay delay',
  analyticsDesc: 'Delay delay delay',
  marketingCookies: 'Delay delay',
  marketingDesc: 'Delay delay delay',
  acceptAll: 'Delay delay',
  essentialOnly: 'Delay delay',
  customize: 'Delay',
  savePreferences: 'Delay delay',
  back: 'Delay',
  readPrivacyPolicy: 'Delay delay delay delay',
  cookiePolicy: 'Delay delay',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI վերdelays',
  aiDraft: 'AI սևdelays',
  smartAssistant: 'Կdelays',

  // 知识库搜索
  enableKnowledgeSearch: 'Միdelays delays',
  knowledgeSearchDesc: 'AI- delays delaysdelays',
  clickToDisable: 'delays',
  clickToEnable: 'delays',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Փակել ռեսուրսների վահանակը',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'Արագ պատասխան',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'Չեղարկել',
  library: 'Գրադարան',
  filterAll: 'Բոլորը',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'Մտածում է...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Ծառայության սխալ',
  uploaded: 'Վերբեռնված',
  settingsGeneral: 'Ընդհանուր',
  settingsNotifications: 'Ծանուցումներ',
  settingsAppearance: 'Արտաքին տեսք',
  settingsProfile: 'Պրոֆիլ',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Լուսավոր',
  settingsDark: 'Մուգ',
  settingsSystem: 'Համակարգ',
  about: 'Մասին',
  reviewTitle: 'Փաստաթղթի վերանայում',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Վերանայում է...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Իրավական փաստաթղթի պատրաստում',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Ստեղծվում է...',
  generatedSuccess: '✅ Փաստաթուղթը ստեղծվել է!',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'Պատմություն',
  drafterNoHistory: 'Պատմություն չկա',
  drafterNewChat: 'Նոր զրույց',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Պահել փաստաթուղթը',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Ելք',
  drafterConfirm: 'Հաստատել',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Պատրաստ',
  workflowCompleted: 'Ավարտված',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Կանգնեցնել',
  restartWorkflow: 'Restart',
  startDrafting: 'Սկսել պատրաստումը',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Պայմանագիր',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Նամակ',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'Խելացի փաստաթղթի օգնական',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'Սխալ',
  unknownError: 'Անհայտ սխալ',
  file: 'Ֆայլ',
  loading: 'Բեռնվում է...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI վերլուծություն',
};
